import { graphql } from 'react-relay';

export const CREATE_PROMOTIONAL_CODE_MUTATION = graphql`
  mutation CreatePromotionalCodeMutation($input: CreatePromotionalCodeInput!) {
    CreatePromotionalCode(input: $input) {
      id
      code
      plan
      planName
      planValueCents
      discountType
      discountValue
      discountDuration
      durationMonths
      appliesTo
      isActive
      maxUses
      currentUses
      expiresAt
      createdAt
    }
  }
`;
